module.exports = __webpack_public_path__ + "static/img/sidebar_logo.4699769.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sidebar_logo.png
// module id = fMFC
// module chunks = 1